module.exports = __webpack_public_path__ + "static/background-small-be6eb77d0435a0e2759e13d722bad52a.svg";